import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ContactContent extends React.Component{

    constructor(){
        super();

        
        this.state = { 
            loading : 1, 
            name:'',
            email:'',
            phone:'',
            message:'',
            errors:{},
            fopen:false,
            success_message:'',
            reg_error:false,
            err_message:"",
            sending:false
            
        }
        

    }

    handleSubmit = (event) => {
        event.preventDefault();
        const errors = {};
        if (!this.state.name) {
            errors.name = 'Name is required';
          }  
          if (!this.state.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.email)) {
          errors.email = 'Invalid email';
        }
        
        if (!this.state.message) {
            errors.message = 'Message is required';
          } 
        if (Object.keys(errors).length > 0) {
          this.setState({ errors });
        } else {
            this.setState({sending:true});
             
            var data = {  name:this.state.name, 'email' :this.state.email, 'phone' :this.state.phone, 'message':this.state.message  }
            axios.post(api_base_url+"send_contact", data).then(response=>{

                if(response.data.error)
                {
                    this.setState({reg_error:true});
                    this.setState({fopen:false});
                    this.setState({err_message: response.data.message});  
                }
                else{
                    
                    this.setState({fopen:true});
                    this.setState({reg_error:false});
                    this.setState({success_message:" Enquiry Successfully Sent."});
                    this.setState({name:'',email:'', phone:'',message:'', sending:false});
                }
                
            }).catch((error) => { 
                  console.log('Conflict error:', error.response);
               
            });

        }
      };
    
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
      };

   

    render()
    { 
        
    return (
<div>
          <div class="bg-gray-light p-tb20">
            	<div class="container">
                    <ul class="wt-breadcrumb breadcrumb-style-2">
                        <li><Link to="/"  ><i class="fa fa-home"></i> Home</Link></li>
                        <li>Contact Us</li>
                    </ul>
                </div>
            </div>
            
            <div class="section-full p-t80 p-b50">
                <div class="container">
                
                 
                    <div class="section-content m-b30">
 
                        <div class="row">
                        
                            <div class="col-md-4 col-sm-12 m-b30">
                                <div class="wt-icon-box-wraper center p-a30 bg-orange">
                                    <div class="icon-sm text-white m-b10"><i class="iconmoon-smartphone-1"></i></div>
                                    <div class="icon-content">
                                        <h5 class="text-white">Phone number</h5>
                                        <p class="text-gray-dark">{this.props.settings.site_factory_number},</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12 m-b30">
                                <div class="wt-icon-box-wraper center p-a30 bg-orange">
                                    <div class="icon-sm text-white m-b10"><i class="iconmoon-email"></i></div>
                                    <div class="icon-content">
                                        <h5 class="text-white">Email address</h5>
                                        <p class="text-gray-dark">{this.props.settings.site_email_address}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12 m-b30">
                                <div class="wt-icon-box-wraper center p-a30 bg-orange">
                                    <div class="icon-sm text-white m-b10"><i class="iconmoon-travel"></i></div>
                                    <div class="icon-content">
                                        <h5 class="text-white">Address info</h5>
                                        <p class="text-gray-dark">{this.props.settings.site_factory_address}</p>
                                    </div>
                                </div>
                            </div>
                        
                        </div>
          
                    </div>
                    
                   
                    <div class="section-content m-b50">
                        <div class="row">
                        
                         
                            <div class="wt-box col-md-6">
                            
                                 <h4 class="text-uppercase">Location</h4>
                                <div class="wt-separator-outer m-b30">
                                   <div class="wt-separator style-square">
                                       <span class="separator-left site-bg-primary"></span>
                                       <span class="separator-right site-bg-primary"></span>
                                   </div>
                               </div>      
                                                        

                                <div class="gmap-outline m-b30">
                                    <div id="gmap_canvas" class="google-map">
                                     <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3631.7694363401206!2d54.3821708!3d24.4587834!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e695988d20165%3A0xcf9db77c1f06c6c8!2sCCME!5e0!3m2!1sen!2sin!4v1761036856046!5m2!1sen!2sin"  width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                    </div>
                                </div>
                                    
                            </div>

                            
                            <div class="wt-box col-md-6">
                            
                                <h4 class="text-uppercase">Contact Form </h4>
                                <div class="wt-separator-outer m-b30">
                                    <div class="wt-separator style-square">
                                       <span class="separator-left site-bg-primary"></span>
                                       <span class="separator-right site-bg-primary"></span>
                                    </div>
                                    
                                </div>
                            
                            	<div class="p-a30 bg-gray">
                            
                                    <form class="cons-contact-form" method="post" action="phpmailer/mail.php">
                            
                                        <div class="row">
                                        
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <span class="input-group-addon"><i class="fa fa-user"></i></span>
                                                         <input class="form-control" id="name" name="name" placeholder="Name" type="text" onChange={this.handleChange} value={this.state.name}  />
                                                        <span class="alert-error">{this.state.errors.name && <label className="error">{this.state.errors.name}</label>}</span>
                                                    </div>
                                                </div>
                                            </div>
            
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                                                        <input class="form-control" id="email" name="email" placeholder="Email*" type="email"  onChange={this.handleChange} value={this.state.email}  />
                                                        <span class="alert-error">{this.state.errors.email && <label className="error">{this.state.errors.email}</label>}</span>
                               
                                                    </div>
                                                </div>
            
                                            </div>
            
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <span class="input-group-addon v-align-t"><i class="fa fa-pencil"></i></span>
                                                        <textarea class="form-control" id="message" name="message" placeholder="Tell Us About Project *"  onChange={this.handleChange} value={this.state.message} ></textarea>
                                    <span class="alert-error">{this.state.errors.message && <label className="error">{this.state.errors.message}</label>}</span>
                               
                                                    </div>
                                                </div>
                                            </div>
            
                                            <div class="col-md-12">
                                                
                                                <button type="submit" name="submit" id="submit" class="site-button  m-r15"   onClick={this.handleSubmit}>
                                    Send Message <i class="fa fa-angle-double-right"></i>
                                </button>
                                <div id={this.state.sending ? "dblock" : "dnone"}> <img src={base_url+"assets/images/loader.gif"} className="Loader" alt="Loader" /></div>
                            
                                                <button name="Resat" type="reset" value="Reset"  class="site-button " >Reset  <i class="fa fa-angle-double-right"></i></button>
                                            </div>

                                            <div class="col-md-12 alert-notification">
                            <div id="message" class="alert-msg">
                                 
                            <div className='alert alert-success '  id={this.state.fopen ? "dblock" : "dnone"}>{this.state.success_message}</div>
                        
                        <div className='alert alert-warning '  id={this.state.reg_error ? "dblock" : "dnone"}>{this.state.err_message}</div>
    
                            </div>
                        </div>
            
                                        </div>
    
                                    </form>
                                
                                </div>
                        
                            </div>
                            
                        </div>
                    </div>
                    
                </div>
           </div>
 </div>
            
    );
}

}

export default ContactContent;